module.exports = __webpack_public_path__ + "img/flagIcons.853b310b.svg";